// extracted by mini-css-extract-plugin
export default {"mCard":"cr-z","image":"dr-z","imageNoBackground":"er-z","fullWidth":"fr-z"};